// Helper to format a Date as YYYY-MM-DD (date-only, local time)
export function toDateOnlyString(d: Date | string | null | undefined): string | null {
  if (!d) return null;
  if (typeof d === 'string') {
    // Assume already date-only or ISO; if it's already yyyy-MM-dd, return as-is
    if (/^\d{4}-\d{2}-\d{2}$/.test(d)) return d;
    // Try to parse string to Date, then format
    const parsed = new Date(d);
    if (isNaN(parsed.getTime())) return null;
    d = parsed;
  }
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function toDisplayDate(d: Date | string | null | undefined): string {
  const s = toDateOnlyString(d);
  return s ?? '';
}
